// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-radar "},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12.0002 2L22.0102 9.27269L18.1868 21.0402H5.81371L1.99023 9.27269L12.0002 2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.0002 2L22.0102 9.27269M12.0002 2L1.99023 9.27269M12.0002 2L12 12.5251M22.0102 9.27269L18.1868 21.0402M22.0102 9.27269L12 12.5251M18.1868 21.0402H5.81371M18.1868 21.0402L12 12.5251M5.81371 21.0402L1.99023 9.27269M5.81371 21.0402L12 12.5251M1.99023 9.27269L12 12.5251","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartRadarIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-radar',
    ref,
    icon: element,
  },
));

ChartRadarIcon.displayName = 'ChartRadarIcon';

export default ChartRadarIcon;
